import React from 'react';
import styled from 'styled-components';
import Select, { components, OptionProps } from 'react-select';

const Row = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const Name = styled.span`
  min-width: 60px;
  color: ${({ theme }) => theme.colors.text};
  margin-right: 12px;
`;

// 커스텀 Option: 체크박스 + 라벨
const CheckboxOption = (props: OptionProps<any>) => (
  <components.Option {...props}>
    <input
      type="checkbox"
      checked={props.isSelected}
      onChange={() => {}}
      style={{ marginRight: 8 }}
      tabIndex={-1}
      readOnly
      aria-label={props.label}
    />
    <span>{props.label}</span>
  </components.Option>
);

interface UnavailableDatesProps {
  names: string[];
  dates: Date[];
  unavailable: { [name: string]: Date[] };
  onChange: (name: string, dates: Date[]) => void;
}

const UnavailableDates: React.FC<UnavailableDatesProps> = ({ names, dates, unavailable, onChange }) => {
  const options = dates.map(date => ({
    value: date.toISOString(),
    label: date.toLocaleDateString('ko-KR', { month: '2-digit', day: '2-digit', weekday: 'short' }),
  }));

  return (
    <div>
      <h4>❌ 참여 불가능한 날짜</h4>
      {names.map(name => (
        <Row key={name}>
          <Name>{name}</Name>
          <Select
            isMulti
            options={options}
            value={unavailable[name]?.map(d => ({
              value: d.toISOString(),
              label: d.toLocaleDateString('ko-KR', { month: '2-digit', day: '2-digit', weekday: 'short' }),
            })) || []}
            onChange={selected =>
              onChange(name, selected.map(s => new Date(s.value)))
            }
            placeholder="날짜 선택"
            components={{ Option: CheckboxOption }}
            closeMenuOnSelect={false}
            styles={{
              container: base => ({ ...base, minWidth: 200 }),
              control: base => ({ ...base, background: '#232323', borderColor: '#333', color: '#fff' }),
              menu: base => ({ ...base, background: '#232323', color: '#fff' }),
              multiValue: base => ({ ...base, background: '#ffb74d', color: '#232323' }),
            }}
          />
        </Row>
      ))}
    </div>
  );
};

export default UnavailableDates; 